import { render, staticRenderFns } from "./ReligionCard.vue?vue&type=template&id=8455dc56&scoped=true&"
import script from "./ReligionCard.vue?vue&type=script&lang=js&"
export * from "./ReligionCard.vue?vue&type=script&lang=js&"
import style0 from "./ReligionCard.vue?vue&type=style&index=0&id=8455dc56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8455dc56",
  null
  
)

export default component.exports